import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import { Session } from 'services';
import httpClient from 'utils/httpClient';

const CHECK_IN = (id: Number) => `/v2/teacher/unit/${id}/checkin`;

export type checkInBody = {
  id: number;
};

export type ConfirmSessionResponse = {
  session: Session;
};

export const checkIn = ({ id }: checkInBody) => {
  let params = {};

  return httpClient.post<ConfirmSessionResponse>(CHECK_IN(id), params);
};

export const useCheckIn = (
  opts?: UseMutationOptions<
    AxiosResponse<ConfirmSessionResponse>,
    AxiosError<any>,
    checkInBody
  >,
) =>
  useMutation<
    AxiosResponse<ConfirmSessionResponse>,
    AxiosError<any>,
    checkInBody
  >(checkIn, opts);
